import { Stage } from './configurations';

export const SERVICE_ENDPOINTS = {
  [Stage.DEV]: 'https://service.beta.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.BETA]: 'https://service.beta.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.GAMMA]: 'https://service.gamma.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.PROD]: 'https://service.prod.contentflywheel.marketing.aws.a2z.org.cn',
};

// Each Portal stage talks to the Connection Management API of its own stage, so a non-prod
// Portal never reaches the prod backend. Global dev/beta use the alpha env (us-west-2) and
// gamma uses the gamma env (us-east-1) -- see CONNECTION_AUTH_CONFIG.global for the matching
// per-stage regions. China maps dev/beta -> beta-cn and gamma -> gamma-cn (all cn-northwest-1).
export const CONNECTION_MANAGEMENT_ENDPOINTS = {
  global: {
    [Stage.DEV]: 'https://9s7j5cyfg7.execute-api.us-west-2.amazonaws.com/alpha',
    [Stage.BETA]: 'https://9s7j5cyfg7.execute-api.us-west-2.amazonaws.com/alpha',
    [Stage.GAMMA]: 'https://wpaocrdvng.execute-api.us-east-1.amazonaws.com/gamma',
    [Stage.PROD]: 'https://t8vb7h9mc8.execute-api.us-east-1.amazonaws.com/prod',
  },
  china: {
    [Stage.DEV]: 'https://844xzmp5y1.execute-api.cn-northwest-1.amazonaws.com.cn/beta',
    [Stage.BETA]: 'https://844xzmp5y1.execute-api.cn-northwest-1.amazonaws.com.cn/beta',
    [Stage.GAMMA]: 'https://dmtdhhczc3.execute-api.cn-northwest-1.amazonaws.com.cn/gamma',
    [Stage.PROD]: 'https://df5mb8sp36.execute-api.cn-northwest-1.amazonaws.com.cn/prod',
  },
};

// Knowledge Engine (KE) is GLOBAL-only at M0 (no China partition). The browser reaches it
// exactly like Connection Management -- SigV4 (service=execute-api) with the SAME global
// ContentConnection Cognito pool (see CONNECTION_AUTH_CONFIG.global); only the base URL differs.
// dev/beta -> alpha env (us-west-2), gamma/prod -> us-east-1. The APIGW stage is named "prod" in
// every account, so the path segment is always /prod. KE features are gated to region === 'global'
// (there is no china entry on purpose); callers must check the region before using this.
export const KNOWLEDGE_ENGINE_ENDPOINTS = {
  global: {
    [Stage.DEV]: 'https://sozp92sekh.execute-api.us-west-2.amazonaws.com/prod',
    [Stage.BETA]: 'https://sozp92sekh.execute-api.us-west-2.amazonaws.com/prod',
    [Stage.GAMMA]: 'https://vzwvrd3eb3.execute-api.us-east-1.amazonaws.com/prod',
    [Stage.PROD]: 'https://9axe298o4l.execute-api.us-east-1.amazonaws.com/prod',
  },
};

// Media Processing API, us-east-1 in every stage. dev uses beta. Beta goes through the
// API's CloudFront, which passes the Cognito Bearer token on; gamma and prod call API Gateway
// directly, because a SigV4 signature covers the Host header that CloudFront replaces.
export const MEDIA_PROCESSING_REGION = 'us-east-1';
export const MEDIA_PROCESSING_ENDPOINTS = {
  [Stage.DEV]: 'https://d2tq46x6qm5a24.cloudfront.net/prod',
  [Stage.BETA]: 'https://d2tq46x6qm5a24.cloudfront.net/prod',
  [Stage.GAMMA]: 'https://ugzvwl6aad.execute-api.us-east-1.amazonaws.com/prod',
  [Stage.PROD]: 'https://jqo22o6vw2.execute-api.us-east-1.amazonaws.com/prod',
};

export const WEBSITE_ENDPOINTS = {
  [Stage.DEV]: 'http://localhost:3000',
  [Stage.BETA]: 'https://portal.beta.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.GAMMA]: 'https://portal.gamma.contentflywheel.marketing.aws.a2z.org.cn',
  [Stage.PROD]: 'https://portal.prod.contentflywheel.marketing.aws.a2z.org.cn',
};

// Allowed origins for iframe embedding / postMessage. Every stage uses an
// explicit allowlist — no wildcard — so only known embedders (the portal itself
// and the brainforce host) can drive the editor or receive its messages.
export const ALLOWED_IFRAME_ORIGINS = {
  [Stage.DEV]: [WEBSITE_ENDPOINTS[Stage.DEV], 'https://dev.brainforce.dci.aws.a2z.org.cn:3000'],
  [Stage.BETA]: [
    WEBSITE_ENDPOINTS[Stage.BETA],
    'https://dev.brainforce.dci.aws.a2z.org.cn:3000',
    'https://beta.brainforce.dci.aws.a2z.org.cn',
  ],
  [Stage.GAMMA]: [WEBSITE_ENDPOINTS[Stage.GAMMA], 'https://gamma.brainforce.dci.aws.a2z.org.cn'],
  [Stage.PROD]: [WEBSITE_ENDPOINTS[Stage.PROD], 'https://brainforce.dci.aws.a2z.org.cn', 'https://prod.brainforce.dci.aws.a2z.org.cn'],
};
